import React, { useEffect, useState } from 'react';
import ContentContainer from 'components/common/contentCont';
// import data from '../../utils/JSON/results.json';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './ResultPage.css';
import axios from '../../services/local/api';
import { useUserContext } from 'UserProvider';

const ResultPage = () => {
  const navigate = useNavigate();
  const [prev, setPrev] = useState([]);
  const { userContext } = useUserContext();
  useEffect(() => {
    const fetch = async () => {
      const userId = userContext?.userData?.id || localStorage.getItem('userId');
      const userName = userContext?.userData?.fullname || localStorage.getItem('username');
      const userEmail = userContext?.userData?.email || localStorage.getItem('userEmail');
      const res1 = await axios({
        url: '/api/results',
        method: 'POST',
        data: {
          email: userEmail,
          name: userName,
          UserId: userId
        },
        headers: {
          'Content-Type': 'application/json'
        }
      });

      setPrev(
        res1?.data?.data?.past_result.sort((a, b) => {
          return new Date(b.examtime) - new Date(a.examtime);
        })
      );
      // console.log(res1.data.data.past_result);
    };

    fetch();
  }, []);
  return (
    <ContentContainer title="Previous Results">
      <div className="dashboard__container resultPage">
        <div className="dashboard__box resultPage_box">
          {prev.length > 0 &&
            prev.map((doc, i) => {
              return (
                <div key={i}>
                  <h1>Result - {i + 1}</h1>
                  <Typography color="secondary">
                    Test Taken at : {new Date(doc.examtime).toDateString()}
                  </Typography>
                  <Typography color="secondary">Exercise Name : {doc.result.exName}</Typography>
                  <Typography color="secondary">TimeTaken : {doc.result.timetaken}</Typography>
                  <Typography color="secondary">Assessment Type : {doc.assessment}</Typography>
                  <Typography color="secondary">Words Per Minute : {doc.result.wpm}</Typography>
                  <Typography color="secondary">Errors : {doc.result.error}</Typography>
                  <Typography color="secondary">Word Count : {doc.result.wordcount}</Typography>
                </div>
              );
            })}
        </div>
      </div>
      <div style={{ width: '100%', marginTop: '50px', textAlign: 'center' }}>
        <button
          onClick={() => navigate(-1)}
          style={{ margin: 'auto' }}
          type="submit"
          className="logoutButton">
          Back
        </button>
      </div>
    </ContentContainer>
  );
};

export default ResultPage;
